import { APP_SAVE_BAR_SCOPE } from "@/modules/app-save-bar";

export const TECHNICAL_FORM_EDITOR_SCOPE =
  APP_SAVE_BAR_SCOPE.TECHNICAL_FORM_EDITOR;
